export const ChecklistItemStates = {
  upcoming: 'upcoming',
  todo: 'todo',
  done: 'done',
  locked: 'locked',
  'radio-positive': 'radio-positive',
  'radio-neutral': 'radio-neutral',
  'radio-negative': 'radio-negative',
} as const

export type ChecklistItemState =
  (typeof ChecklistItemStates)[keyof typeof ChecklistItemStates]

export const getChecklistItemStateNumberArray = Object.values(
  ChecklistItemStates
).map((_, index) => index)

export const getChecklistItemStateValue = (state: ChecklistItemState) => {
  const entries = Object.entries(ChecklistItemStates)
  return entries.findIndex(([_, value]) => value === state) || 0
}
